'use es6';

export const ENABLED = ['enabled'];
export const TIME_DELAY_SECONDS = ['timeDelaySeconds'];